import { render, staticRenderFns } from "./ImportToAddCompany.vue?vue&type=template&id=ec749ef8&scoped=true&"
import script from "./ImportToAddCompany.vue?vue&type=script&lang=js&"
export * from "./ImportToAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./ImportToAddCompany.vue?vue&type=style&index=0&id=ec749ef8&prod&lang=less&scoped=true&"
import style1 from "./ImportToAddCompany.vue?vue&type=style&index=1&id=ec749ef8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec749ef8",
  null
  
)

export default component.exports